export interface TopUpInfo {
  description: string;
  name: string;
}

export interface CreateTopUpPayment {
  phoneNumber: string;
  amount: number;
  consents: number[];
}

export const TopUpErrorHeader = {
  TOP_UP_CANNOT_BE_EXECUTED_FOR_LIABILITY: 'Błąd doładowania',
  TOP_UP_CANNOT_BE_EXECUTED_FOR_PAYMENT: 'Błąd doładowania',
  PAYMENT_ALREADY_STARTED: 'Istnieje rozpoczęta płatność',
  TOP_UP_CANNOT_BE_EXECUTED: 'Napotkaliśmy problem',
  TOP_UP_CLIENT_ERROR: 'Błąd pośrednika',
  INVALID_LIABILITIES_PAYMENT_TYPE: 'W koszyku istnieją opłaty innego typu',
};
export const TopUpErrorDescription = {
  TOP_UP_CANNOT_BE_EXECUTED_FOR_LIABILITY: 'Ten numer telefonu nie może zostać doładowany.',
  TOP_UP_CANNOT_BE_EXECUTED_FOR_PAYMENT: 'Ten numer telefonu nie może zostać doładowany.',
  PAYMENT_ALREADY_STARTED: 'Aby wykonać tę operację dokończ lub anuluj poprzednią płatność.',
  TOP_UP_CANNOT_BE_EXECUTED: 'Podany numer nie może zostać doładowany na naszej platformie.',
  TOP_UP_CLIENT_ERROR:
    'Przepraszamy, ale w tym momencie doładowanie telefonu nie jest możliwe. Spróbuj ponownie później.',
  INVALID_LIABILITIES_PAYMENT_TYPE:
    'Z powodów technicznych nie można mieszać doładowań z fakturami innych typów. ' +
    'Dokończ płatność za koszyk, bądź opróżnij go, aby móc zrealizować doładowanie telefonu.',
};

export enum TopUpPaymentError {
  TOP_UP_CANNOT_BE_EXECUTED_FOR_LIABILITY = 'TOP_UP_CANNOT_BE_EXECUTED_FOR_LIABILITY',
  TOP_UP_CANNOT_BE_EXECUTED_FOR_PAYMENT = 'TOP_UP_CANNOT_BE_EXECUTED_FOR_PAYMENT',
}

export enum TopUpCartErrors {
  PAYMENT_ALREADY_STARTED = 'PAYMENT_ALREADY_STARTED',
  TOP_UP_CANNOT_BE_EXECUTED = 'TOP_UP_CANNOT_BE_EXECUTED',
  TOP_UP_CLIENT_ERROR = 'TOP_UP_CLIENT_ERROR',
  INVALID_LIABILITIES_PAYMENT_TYPE = 'INVALID_LIABILITIES_PAYMENT_TYPE',
}
